var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1701",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1699",
    d: "m 50,4.6171875 c -18.71436,0 -34.001953,15.2924835 -34.001953,34.0000005 0,7.599819 2.517155,14.677781 6.757812,20.347656 L 22.376953,58.390625 40.466797,89.722656 40.34375,89.498047 c 0.07672,0.147603 0.306629,0.540685 0.550781,0.931641 a 5.8009803,5.8009803 0 0 0 0.689453,0.542968 l -0.404296,-0.09961 c 1.953492,2.701908 5.242784,4.51367 8.835937,4.513672 3.319933,0 6.324027,-1.577619 8.251953,-3.832031 l -0.554687,0.09375 a 5.8009803,5.8009803 0 0 0 1.126953,-0.859376 c 0.437127,-0.60428 0.911364,-1.325375 1.292968,-2.271484 l -0.355468,0.730469 17.720703,-30.697266 -0.402344,0.605469 c 4.326393,-5.700673 6.90625,-12.849342 6.90625,-20.539062 C 84.001953,19.909671 68.71436,4.6171875 50,4.6171875 Z M 49.720703,30.925781 c 4.543192,0 8.09375,3.554176 8.09375,8.09375 0,4.539574 -3.550558,8.09375 -8.09375,8.09375 -4.543695,0 -8.09375,-3.552768 -8.09375,-8.09375 0,-4.539574 3.550558,-8.09375 8.09375,-8.09375 z m -8.902344,59.40625 c 0.01367,0.02344 0.04622,0.07422 0.04883,0.07617 z m 18.279297,0.08984 -0.226562,0.34375 a 5.8009803,5.8009803 0 0 0 0.04687,-0.03516 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    style: {
      fill: "#ff8661",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,10.417c-15.581,0-28.201,12.627-28.201,28.201c0,6.327,2.083,12.168,5.602,16.873L45.49,86.823   c0.105,0.202,0.21,0.403,0.339,0.588l0.04,0.069l0.011-0.006c0.924,1.278,2.411,2.111,4.135,2.111c1.556,0,2.912-0.708,3.845-1.799   l0.047,0.027l0.179-0.31c0.264-0.356,0.498-0.736,0.667-1.155L72.475,55.65c3.592-4.733,5.726-10.632,5.726-17.032   C78.201,23.044,65.581,10.417,50,10.417z M49.721,52.915c-7.677,0-13.895-6.221-13.895-13.895c0-7.673,6.218-13.895,13.895-13.895   s13.895,6.222,13.895,13.895C63.616,46.693,57.398,52.915,49.721,52.915z",
    id: "path2",
    style: {
      fill: "#ff8661",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.2eccae78103834cdc76ddcc2b5f2bb10.svg";
export { ForwardRef as ReactComponent };